module.exports = __webpack_public_path__ + "static/media/Spotify.1fd2f614.png";